export default __webpack_public_path__ + "ui/assets/img/upload-20.svg";